// Инициализация и трекинг Meta (Facebook) Pixel

// ID пикселя, предоставленный заказчиком
const PIXEL_ID = "842794244906579";

/**
 * Встраивает скрипт fbevents.js и подготавливает глобальную функцию fbq.
 * Повторные вызовы безопасны: если fbq уже есть, ничего не делаем.
 */
const ensurePixelSnippet = () => {
  // Если уже есть fbq, повторно не вставляем
  if (typeof window === "undefined" || window.fbq) return;

  // Официальный сниппет Meta Pixel: создаём заглушку fbq и подключаем внешний скрипт
  (function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
};

/**
 * Инициализирует пиксель, если он ещё не инициализирован.
 * Не шлёт PageView автоматически — это делаем при смене роутов.
 */
export const initFacebookPixel = () => {
  if (typeof window === "undefined") return;

  // Защита от повторной инициализации одним и тем же ID
  if (window.__FB_PIXEL_INITIALIZED) return;

  ensurePixelSnippet();

  try {
    // Инициализация с ID пикселя
    window.fbq("init", PIXEL_ID);
    window.__FB_PIXEL_INITIALIZED = true;
    window.__FB_PIXEL_ID = PIXEL_ID;
  } catch (e) {
    // В нештатных ситуациях (например, если fbq недоступен) — просто не падаем
    // и не блокируем приложение
    console.warn("Meta Pixel init error:", e?.message || e);
  }
};

/**
 * Шлёт событие PageView, если fbq доступен (скрипт либо загрузился, либо событие встанет в очередь).
 */
export const trackFacebookPageView = () => {
  if (typeof window === "undefined") return;
  try {
    if (window.fbq) window.fbq("track", "PageView");
  } catch (e) {
    console.warn("Meta Pixel PageView error:", e?.message || e);
  }
};

/**
 * Универсальная отправка событий, если понадобится в будущем.
 * @param {string} name
 * @param {Object} [params]
 */
export const trackFacebookEvent = (name, params) => {
  if (typeof window === "undefined") return;
  try {
    if (window.fbq) window.fbq("track", name, params || {});
  } catch (e) {
    console.warn("Meta Pixel track event error:", e?.message || e);
  }
};
